<script>
// Shown instead of a post that is offline (`online: false`) in the current
// locale: lets the visitor pick the blog or the post's other-language version.
import Navbar from '@/components/Navbar'
import isOnline from '@/helpers/online'

export default {
  name: 'offline-choice',
  components: { Navbar },
  computed: {
    locale(){
      return this.$i18n.locale === 'de' ? 'de' : 'en';
    },
    otherLocale(){
      return this.locale === 'de' ? 'en' : 'de';
    },
    // the post this page stands in for; only real routes count
    post(){
      const name = this.$route.query.post;
      return typeof name === 'string' && this.$router.options.routes.some(r => r.name === name) ? name : null;
    },
    otherAvailable(){
      return !!this.post && isOnline(this.post, this.otherLocale);
    }
  },
  methods: {
    // The locale watcher in App.vue then opens the post in the new language.
    readInOther(){
      // read it once: after the assignment `otherLocale` flips to the old language
      const target = this.otherLocale;
      this.$i18n.locale = target;
      try { window.localStorage.setItem('locale', target); } catch (e) { /* storage blocked */ }
    }
  }
}
</script>

<template>
  <div>
    <navbar :lightTheme="true" :blogpost="true" />

    <v-container class="offline-choice py-12" data-testid="offline-choice">
      <h1 class="primary--text mb-4">
        {{ otherAvailable ? $t('offlineChoice.title') : $t('offlineChoice.titleGone') }}
      </h1>
      <p v-if="otherAvailable" class="mb-8">{{ $t('offlineChoice.text') }}</p>

      <div class="d-flex flex-wrap" style="gap: 1rem">
        <v-btn color="primary" depressed :to="{ name: 'blog' }" data-testid="choice-blog">
          {{ $t('offlineChoice.blog') }}
        </v-btn>
        <v-btn v-if="otherAvailable" outlined color="primary" data-testid="choice-other-language"
               @click="readInOther">
          {{ $t('offlineChoice.readIn', { lang: $t('offlineChoice.' + otherLocale) }) }}
        </v-btn>
      </div>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
.offline-choice {
  max-width: 820px;
  // the navbar is fixed and does not push the page down: its unscrolled height
  // (100px; 130px from the md breakpoint, see Navbar.vue) plus the usual 48px
  padding-top: 148px !important;

  @media (min-width: 960px) {
    padding-top: 178px !important;
  }
}
</style>
